<template>
	<page-with-aside :hasFooter="true">
	
		<template #navheader>
            <site-header></site-header>
        </template>
        
		<template #content>
			 <section class="content-header">
 				<h3>When you're done, you’ll have a list of questions and concerns to share so that your doctor understands your needs. Together, you’ll be better able to make the treatment decisions that are right for you.</h3>
 				<button @click="showModal">See a sample of a finished list</button>
 				<modal v-show="isModalVisible" @close="closeModal">
 					<template v-slot:modalName>
 						Finished Question List
 					</template>
 					<template v-slot:modalHeaderText>
 						<p>This is not from a real patient. It is an example of a final list, which includes:</p>
	<ul>
    <li>Details about your situation</li>
    <li>Your understanding of your options</li>
    <li>Your support network</li>
    <li>Your goals and priorities</li>
    <li>Your questions and concerns</li>
		</ul>
 					</template>
 					<template v-slot:modalBody>
 					
 		<picture>
 			<source media="(min-width: 900px)" srcset="/images/final_summary-laptop.png">
    		<source media="(min-width: 600px)" srcset="/images/final_summary-ipad.png">
    		<img src="/images/final_summary-phone.png" alt="sample of a finished question list">		
 		</picture>
 	
 					</template>
 				</modal>
			</section>

 	<article class="grid-section">
 		<section class="content">
 		<h4>Here's how it works:</h4>
 			<p>The Open to Options chatbot will:</p>
 			<ul>
 				<li>help you think about the information and questions you'd like to share with your doctor</li>
<li>offer guidance and suggestions along the way</li>
</ul>

<p>Before you start, it's best to have a quiet place to work and about 30 minutes without interruptions. </p>

<p>You can take breaks and save your work along the way. Don’t worry if you forget to include something&mdash;you can always add it later.</p>
 		</section>
 	
		<section class="chat-peek">
        	<div class="message slide-in-left one">We'll help you organize your questions about:</div>
        	<div class="message slide-in-left two">your situation&hellip;</div>
        	<div class="message slide-in-left three">your treatment options&hellip;</div>
        	<div class="message slide-in-left four">your support network&hellip;</div>
	<div class="message slide-in-left five">your goals&hellip;</div>
	<div class="message slide-in-left six">and your worries and concerns.</div>
        	<div class="message-response slide-in-right">
         		<span><button><router-link to="/eligibility">How do I get started?</router-link> <!-- TODO: fix -->
</button></span>
         	</div>
    	</section>
    </article>
    </template>
	</page-with-aside>
</template>

<style scoped lang="scss">
.grid-section {
	overflow-x:hidden;
}
.slide-in-left {
	transform: translateX(-1000px);
	-webkit-animation: slide-in-left 1.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;
	animation: slide-in-left 1.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;
	opacity:0;
	&.one {
	animation-delay: 2s;
	}
	&.two {
	animation-delay: 4s;
	}
	&.three {
	animation-delay: 6s;
	}
	&.four {
	animation-delay: 8s;
	}
	&.five {
	animation-delay: 10s;
	}
	&.six {
	animation-delay: 12s;
	}
}

@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
            transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
     transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-right {
	-webkit-animation: slide-in-right 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	animation: slide-in-right 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	animation-delay: 14s;
	opacity:0;
}
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
            transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
            transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}
.modal-header {
ul {
  	//display: grid;
  	//grid-template-columns: repeat(auto-fit,minmax(180px, 1fr)); 
  	//grid-gap:1rem;
}
li {padding:0 1rem 0 0;}

}
.modal-img {
	width:90%;
	height:auto;
}
.modal {
	h2, ul, li {margin:0;}
	p {margin-bottom:.5rem;}
}	
</style>

<script>
  import PageWithAside from '@/components/PageWithAside.vue';
  import SiteHeader from '@/components/siteHeader.vue';
   import modal from '@/components/modal.vue';
  
  export default {
    name: "Intro",
    components: {
		"site-header": SiteHeader,
		PageWithAside,
		modal
    },
    data () {
      return {
        isModalVisible: false,
      };
    },
	methods: {
      goToChat() {
        this.$router.push('/chat/situation/new/');
        this.changeMode("chat");
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    }
  };
</script>